import { render, staticRenderFns } from "./BlockDetails.vue?vue&type=template&id=43e4c860&scoped=true"
import script from "./BlockDetails.vue?vue&type=script&lang=js"
export * from "./BlockDetails.vue?vue&type=script&lang=js"
import style0 from "./BlockDetails.vue?vue&type=style&index=0&id=43e4c860&prod&scoped=true&lang=css"
import style1 from "./BlockDetails.vue?vue&type=style&index=1&id=43e4c860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e4c860",
  null
  
)

export default component.exports